import Axios from 'axios';
import qs from 'qs';
import { getCookie } from '../utils/tools';

const pubToken = getCookie('pub_token');
let baseURL = '/';
if (getQuery('invoiceType')) {
  // 为散客pc的请求域名专门做的判断
  switch (window.location.host) {
    case 'testpc.lotsmall.cn': // saas测试环境
      baseURL = 'https://www.lotsmall.cn/';
      break;
    case 'preweb.lotsmall.cn': // saas预发环境
      baseURL = 'https://www.lotsmall.cn/';
      break;
    case 'web.lotsmall.cn': // saas线上环境
      baseURL = 'https://www.lotsmall.cn/';
      break;
    case 'ccnwlotsmg.sendinfo.com.cn': // 八达岭测试环境
      baseURL = 'https://mg.badalingmall.com/';
      break;
    case 'mg.badalingmall.com': // 八达岭线上环境
      baseURL = 'https://mg.badalingmall.com';
      break;
    default:
      break;
  }
}
console.log('baseURL', baseURL);
const instance = Axios.create({
  baseURL,
  timeout: 20000,
  headers: { token: pubToken || 'b2e9f2b1-b6c9-4fe6-be4f-a27fc373285d' },
});

instance.interceptors.request.use(config => {
  let otherParams = {
    corpCode: getCookie('pub_corp_code') || config.corpCode || '',
  };
  if (getQuery('invoiceType')) {
    // 针对散客pc需要请求接口加上其他参数
    otherParams = Object.assign(otherParams, { applySubjectId: getQuery('applySubjectId'), applierId: getQuery('uid') });
  }
  if (config.method === 'post' && config.type === 'json') {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    config.data = Object.assign(config.data, otherParams);
  } else if (config.method === 'post' && config.type !== 'json') {
    config.data = qs.stringify(Object.assign(config.data, otherParams));
  } else if (config.method === 'get') {
    config.data = qs.stringify(Object.assign(config.params, otherParams));
  }
  return config;
});

instance.interceptors.response.use(res => {
  const response = res.data;
  if (Number(response.status) === 200) {
    return Promise.resolve(response);
  } else {
    return Promise.reject(response);
  }
}, err => {
  return Promise.reject(err);
});

function getQuery(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  const arr = [];
  const value = [];
  vars.forEach(item => {
    const pair = item.split('=');
    arr.push(pair[0]);
    value.push(pair[1]);
  });
  if (arr.indexOf(variable) !== -1) {
    return value[arr.indexOf(variable)];
  } else {
    return false;
  }
}
export default instance;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sditest/electronic-invoice-api/src/utils/request.js
// module id = TzB5
// module chunks = 70